import { render, staticRenderFns } from "./PendingActivity.vue?vue&type=template&id=68408d21&scoped=true"
import script from "./PendingActivity.vue?vue&type=script&lang=js"
export * from "./PendingActivity.vue?vue&type=script&lang=js"
import style0 from "./PendingActivity.vue?vue&type=style&index=0&id=68408d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68408d21",
  null
  
)

export default component.exports